<div class="rounded-lg border border-slate-200 bg-slate-50/80 px-4 py-3">
  <p class="text-xs text-slate-500">{{ label() }}</p>
  <p class="mt-1 text-[15px] font-semibold text-slate-900">{{ value() || '—' }}</p>
</div>
